// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  background-color: var(--bg-secondary);
  color: var(--text-primary);
  padding: 2px 4px;
  border-radius: 4px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Mobile touch optimizations */
@media (max-width: 768px) {
  * {
    -webkit-tap-highlight-color: transparent;
  }

  /* Prevent text selection during touch interactions */
  .dragging {
    -webkit-user-select: none;
    user-select: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE;aACW;EACX,qCAAqC;EACrC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA,+BAA+B;AAC/B;EACE;IACE,wCAAwC;EAC1C;;EAEA,qDAAqD;EACrD;IACE,yBAAyB;IAGzB,iBAAiB;EACnB;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n  padding: 2px 4px;\n  border-radius: 4px;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Mobile touch optimizations */\n@media (max-width: 768px) {\n  * {\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  /* Prevent text selection during touch interactions */\n  .dragging {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
